import React from "react";
import { Link } from "react-router-dom";
import Page_Header from '../../../assets/images/background/pricing-page-bg.png';
import Page_01 from '../../../assets/images/about/arrow-brudcrumb.svg';
const PageHeader = () => {
    return (
        <>
            <div
                className="page-header-section"
                style={{
                    backgroundImage: {Page_Header}
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-8">
                            <div
                                className="page-header-heading animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <h2>Pricing Plans</h2>
                                <p>
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews. Iterative approaches to collaborative .
                                </p>
                            </div>
                        </div>
                    </div>
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <img src={Page_01} alt="icon" />
                        </li>
                        <li>
                            <span>Pricing</span>
                        </li>
                    </ul>
                </div>
            </div >

        </>
    )
}
export default PageHeader;